export {
  BULK_ACTION_FOOTER_BTNS_REVERSE,
  BULK_ACTION_FOOTER_OBJECTS,
  BULK_ACTION_OBJ_ACCOUNTS,
  BULK_ACTION_OBJ_ENTITLEMENTS,
  BULK_ACTION_OBJ_PARENT_ENTITLEMENTS,
  BULK_ACTION_OBJ_ROLES,
  BULK_ACTION_OBJ_USERS,
  COMMENT_MINIMUM_LENGTH,
  getBulkActionFooterBtns,
  TRANSITION_TIMEOUT,
} from '../constant';

export const BULK_ACTION_CONSULT_ICON_MAP_FOR_STATS = {
  totalUsers: { icon: 'User', title: 'User' },
  totalAccounts: { icon: 'Account', title: 'Account' },
  totalRoles: { icon: 'Role', title: 'Role' },
  totalEntitlements: { icon: 'Entitlement', title: 'Entitlement' },
  totalParentEntitlements: { icon: 'Entitlement', title: 'Entitlement' },
  totalChildEntitlements: { icon: 'Entitlement', title: 'Entitlement' },
};

export const BULK_ACTION_CONSULT_SUFFIX_MESSAGE = '';
